module.exports = __webpack_public_path__ + "static/media/skicross.1a7f9f66.png";